export class CashMovementState {
  sources: Array<string>;
  currencies: Array<string>;

  constructor(sources: Array<string>, currencies: Array<string>) {
    this.sources = sources;
    this.currencies = currencies;
  }
}
